import React from "react";

const NotFoundComponent = () => {
  return (
    <div className="container-fluid" style={{ padding:"100px 5px 0px 5px" }}>
      <div className="container text-center mt-5" style={{ height:"400px", display:"flex", justifyContent:"center", alignContent:"center" }}>
        <div>
        {/* Icône d'erreur */}
        <i className="bi bi-exclamation-circle" style={{ fontSize: "6rem", color: "#dc3545" }}></i>

        {/* Message principal */}
        <h3 className="mt-4">Aucun véhicule ou propriété trouvé</h3>
        <p className="text-muted">
          Désolé, nous n{"'"}avons pas pu trouver de véhicule ou de propriété correspondant à votre recherche.
        </p>

        {/* Bouton de retour */}
        <a href="/" className="btn btn-primary mt-3">
          <i className="bi bi-arrow-left"></i> Recharger
        </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundComponent;